import { createDraftSafeSelector } from '@reduxjs/toolkit';

import type { RootState } from '../../../App/Store';

export const getState = (state: RootState) => state.translations;

export const getSelectedLanguage = createDraftSafeSelector(
  getState,
  ({ selectedLanguage }) => selectedLanguage,
);

export const getTranslations = createDraftSafeSelector(
  getState,
  ({ messages }) => messages ?? {},
);
